import type { PageLoad } from './$types';



export const load = (async ({ url }) => {

    let filter: SearchFilter = {}
    url.searchParams.forEach((value:string, key: string) => {
        if(key.startsWith('filter[')){
            // @ts-ignore
            filter[key] = value
        }

    })

    return {
        page_title: "Clients",
        pageSize: url.searchParams.get('pageSize') || 10,
        page: url.searchParams.get('page') || 1,
        sort: url.searchParams.get('sort') || 'name',
        search: url.searchParams.get('search')  || '',
        order: url.searchParams.get('order') || 'asc',
        ...filter
    };

}) satisfies PageLoad;